import { CgsEvent } from '@cgs/wge';

export class BuyFreeSpinsEvent extends CgsEvent {}
